<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (displayList) {
    <div>
      <div class="mb-3 col-12">
        <mwp-table [tableColumns]="QLEColumns" [dataSource]="QLETableData" (emitButtonSelection)="startEnrollment($event)" (emitButtonSelection2)="viewEvent($event)" header="Life Events" />
      </div>
      <div class="d-flex justify-content-end">
        <button class="mwp-button-save" (click)="buildNewRequest()">
          <mwp-text-translate text="New Request" jsonKey="qleNewRequest" />
        </button>
      </div>
    </div>
  }
  @if (displayForm) {
    <mwp-member-qle-form [myQLERequestModel]="selectedQLE" [isNewRequest]="isNewRequest" (closeEmit)="closeForm()" (reloadEmit)="loadList()" />
  }
</div>